import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { SupportAgentTicket } from "@src/types/support";

export interface PatchTicketSourceIdResult {
  success: boolean;
  data?: SupportAgentTicket;
  error?: string;
}

export const patchTicketSourceIdUseCase = async (
  machineId: string,
  ticketId: string,
): Promise<PatchTicketSourceIdResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.patchTicketSourceId(
      namespace,
      ticketId,
      machineId,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to update ticket machine")
        .message,
    };
  }
};
